import { useRef } from "react";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Container } from "react-bootstrap";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import downloadIcon from "../../assets/images/downloadIcon.svg";
import viewPdfIcon from "../../assets/images/downloadPdfIcon.svg";
import { downloadAzureContainer } from "../../apis/downloadAzureContainer";
import { changeDateFormat, toastMessages, showToast } from "../../utils";

const columns = [
  { field: "Version", header: "Version" },
  { field: "Filename", header: "Filename" },
  { field: "Owner", header: "Owner" },
  { field: "Timestamp", header: "Date" },
  { field: "Action", header: "Action" },
];

export default function VersionListPopUp({
  visible,
  onCancel,
  selectedJobVersionDetails,
  tableData,
  projectDetails,
  setPDFViewerInfo,
  setShowPDFViewer
}) {
  const toast = useRef(null);

  const dynamicColumns = () => {
    return [
      columns.map((col, i) => (
        <Column key={i} field={col.field} header={col.header} body={renderMappingBody} />
      )),
    ];
  };

  const downloadPdf = async (e, colDetails) => {
    e.preventDefault();

    const targetFolder = "TD";

    // Find the folder that exists in the file path
    const matchedFolder = colDetails?.Filepath?.endsWith(".pdf")
      ? colDetails?.Filepath?.includes(targetFolder)
      : "";
    const fileGroup = colDetails?.FileGroup;

    const basePath = `${projectDetails?.BU}/${
      projectDetails?.Region
    }/${projectDetails?.ProjectID?.toUpperCase()}/${selectedJobVersionDetails?.folderName}/${selectedJobVersionDetails?.jobId}`;

    let folderStructure = "";

    if (matchedFolder) {
      folderStructure = `${basePath}/${targetFolder}/${colDetails?.Version}`;
    } else if (fileGroup) {
      folderStructure = `${basePath}/${fileGroup}/${colDetails?.Version}`;
    } else {
      folderStructure = `${basePath}/${colDetails?.Version}`;
    }

    try {
      await downloadAzureContainer(colDetails?.Filename?.replaceAll("%20", " "), folderStructure);

      // Show success toast once download is complete
      showToast(toast, "success", toastMessages.downloadComplete.detail, {
        life: 3000,
        clearPrevious: true,
      });
    } catch (error) {
      // Show error toast if the download fails
      showToast(toast, "error", toastMessages.downloadFailed.detail, {
        life: 3000,
        clearPrevious: true,
      });
    }
  };

  const viewPdf = async (e, colDetails) => {
    e.preventDefault();
    setShowPDFViewer(true)
    setPDFViewerInfo({
      headerName: selectedJobVersionDetails?.jobName,
      proofscopeURL: colDetails?.ReadOnlyURL,
    });
  };

  const renderMappingBody = (options, rowData) => {
    let { field } = rowData;

    return (
      <>
        {(field === "Version" || field === "Filename") && <span>{options[field]}</span>}
        {field === "Owner" && (
          <div>
            <span>{options[field]}</span>
            <br />
            <span>{options["Email"]}</span>
          </div>
        )}
        {field === "Timestamp" && <span>{changeDateFormat(options[field])}</span>}
        {field === "Action" && (
          <div>
            <img
              src={downloadIcon}
              alt="downloadicon"
              className="download_icon"
              onClick={(e) => downloadPdf(e, options)}
            />

            <img
              alt="viewpdficon"
              src={viewPdfIcon}
              className="view_pdf_icon"
              onClick={(e) => viewPdf(e, options)}
            />
          </div>
        )}
      </>
    );
  };

  return (
    <>
      <Toast ref={toast} />
      <Dialog
        header={selectedJobVersionDetails?.jobName}
        visible={visible}
        onHide={onCancel}
        style={{ width: "75vw" }}
        maximizable
      >
        <Container>
          <DataTable
            stripedRows
            size={"small"}
            scrollable
            responsiveLayout="scroll"
            className="mt-3"
            tableStyle={{
              width: "max-content",
              minWidth: "100%",
            }}
            value={tableData}
            emptyMessage="List unavailable"
          >
            {dynamicColumns()}
          </DataTable>
        </Container>
      </Dialog>
    </>
  );
}
